/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `CommandCenterView.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { CommandCenterView } from "./CommandCenterView";

import { ApiKey } from "./ApiKey";
import { CommandCenterSection } from "./CommandCenterSection";
import { Project } from "./Project";
import { User } from "./User";

export abstract class CommandCenterViewModel {
    id: number;
    apiKeyId: number | null;
    createdAt: Dayjs;
    name: string;
    projectId: number;
    publicUrl: string | null;
    updatedAt: Dayjs;
    userId: number | null;
    apiKey: ApiKey | null | undefined;
    commandCenterSections: CommandCenterSection[] | undefined;
    project: Project | null | undefined;
    user: User | null | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        apiKeyId: number | null,
        createdAt: Dayjs,
        name: string,
        projectId: number,
        publicUrl: string | null,
        updatedAt: Dayjs,
        userId: number | null,
        apiKey: ApiKey | null | undefined,
        commandCenterSections: CommandCenterSection[] | undefined,
        project: Project | null | undefined,
        user: User | null | undefined
    ) {
        this.id = id;
        this.apiKeyId = apiKeyId;
        this.createdAt = createdAt;
        this.name = name;
        this.projectId = projectId;
        this.publicUrl = publicUrl;
        this.updatedAt = updatedAt;
        this.userId = userId;
        this.apiKey = apiKey;
        this.commandCenterSections = commandCenterSections;
        this.project = project;
        this.user = user;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): CommandCenterView {
        const newObject = new CommandCenterView(
            json["id"],
            json["api_key_id"],
            dayjs(json["created_at"]).tz(timezone),
            json["name"],
            json["project_id"],
            json["public_url"],
            dayjs(json["updated_at"]).tz(timezone),
            json["user_id"],
            json["api_key"] == null ? json["api_key"] : ApiKey.fromApiObject(json["api_key"], timezone),
            json["command_center_sections"]?.map((item: any) => CommandCenterSection.fromApiObject(item, timezone)),
            json["project"] == null ? json["project"] : Project.fromApiObject(json["project"], timezone),
            json["user"] == null ? json["user"] : User.fromApiObject(json["user"], timezone)
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(): any {
        return {
            id: this.id,
            api_key_id: this.apiKeyId,
            created_at: this.createdAt,
            name: this.name,
            project_id: this.projectId,
            public_url: this.publicUrl,
            updated_at: this.updatedAt,
            user_id: this.userId,
            command_center_sections_attributes: this.commandCenterSections?.map((item) => item.toApiObject()),
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): CommandCenterView {
        const clone = Object.create(this) as CommandCenterView;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
